var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1420,
    height: 906,
    viewBox: "0 0 1420 906",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_53645)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26_53645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_53645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -66,
    y: 30,
    width: 1547,
    height: 846
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1481 30.1562H-66V875.156H1481V30.1562Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_53645)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.15 570.513C973.006 493.317 949.385 496.556 962.026 418.774C974.668 340.992 992.671 225.719 1102.87 225.43C1213.08 225.141 1281.05 244.337 1315.97 306.079C1350.89 367.821 1402.78 465.424 1316.06 529.614C1229.35 593.804 1109.3 647.708 1041.15 570.513Z",
    fill: "#F5F8FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.78 758.727C962.695 704.264 946.03 706.548 954.946 651.667C963.863 596.786 983.179 533.826 1052.55 521.985C1121.92 510.143 1183.32 510.06 1207.95 553.622C1232.59 597.183 1265.91 684.582 1204.73 729.869C1143.56 775.156 1058.86 813.19 1010.78 758.727Z",
    fill: "#F5F8FF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.524 46.1004C546.002 86.5124 628.866 225 628.866 373.838C628.866 522.676 489.532 610.945 338.482 610.945C187.432 610.945 -60 490.286 -60 341.445C-60 192.604 37.046 5.68838 291.524 46.1004Z",
    fill: "#F5F8FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_26_53645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 243,
    y: 364,
    width: 463,
    height: 331
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M705.299 364.021H243.433V694.114H705.299V364.021Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_26_53645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.078 502.955C249.902 528.082 251.726 553.208 253.55 578.332C255.13 600.098 255.35 622.742 260.827 643.987C265.765 663.142 276.627 679.787 295.354 687.634C313.578 695.271 334.007 694.172 353.341 693.901L505.849 691.754C531.434 691.394 557.017 690.917 582.601 690.454C607.829 689.999 633.153 690.139 658.357 688.971C670.989 688.384 683.589 687.871 696.234 687.753C698.809 687.728 698.815 683.725 696.234 683.753C671.651 683.992 647.064 683.173 622.473 683.209C598.55 683.243 574.627 683.277 550.704 683.309C501.862 683.379 453.019 683.745 404.177 684.009C380.963 684.135 357.694 684.74 334.484 684.295C316.547 683.95 296.926 681.619 284.046 667.741C270.952 653.634 268.515 632.401 267.039 614.065C265.15 590.606 263.748 567.097 262.11 543.619L257.061 471.219C256.281 460.038 255.218 448.831 254.899 437.626C254.613 427.555 254.968 416.733 259.785 407.626C267.692 392.677 284.785 388.232 300.459 386.926C322.848 385.061 345.584 385.439 368.039 384.798L513.115 380.654L584.659 378.611C596.914 378.261 609.169 377.911 621.425 377.561C632.27 377.25 643.263 376.412 654.107 377.084C662.971 377.634 671.726 380 677.985 386.646C683.602 392.608 686.253 400.746 687.878 408.604C689.73 417.565 690.078 426.787 690.218 435.912C690.407 447.927 690.495 459.944 690.634 471.96L692.314 617.292C692.452 629.241 692.878 641.184 693.229 653.128C693.455 660.836 705.19 660.883 705.238 653.128C705.557 602.028 704.557 550.928 703.966 499.828C703.689 475.816 704.073 451.69 702.966 427.701C702.14 409.793 699.46 389.069 685.666 376.111C669.763 361.167 646.409 364.031 626.393 364.642L550.874 366.942L398.843 371.573C373.339 372.349 347.833 373.031 322.333 373.921C304.459 374.546 285.597 374.596 269.282 382.935C251.212 392.172 244 410.597 243.48 430.021C243.166 441.766 244.493 453.567 245.342 465.268L248.078 502.955Z",
    fill: "#F5F8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_26_53645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1216,
    y: 153,
    width: 281,
    height: 388
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.27 153.677L1216.23 487.508L1311.95 540.566L1496.99 206.735L1401.27 153.677Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_26_53645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1399.72 159.376C1405.32 172.767 1411.62 185.767 1415.91 199.679C1420.23 213.655 1423.08 228.044 1424.41 242.613C1426.92 270.75 1423.96 299.105 1415.7 326.119C1407.95 351.213 1396.12 374.859 1380.67 396.103C1364.5 418.601 1344.55 438.115 1321.69 453.774C1309.84 461.87 1297.23 468.786 1284.03 474.422C1270.92 479.978 1257.4 483.443 1243.68 486.966C1253.65 477.319 1264.15 468.214 1274.69 459.2C1279.69 454.917 1271.07 448.055 1267.86 452.939C1254.35 464.26 1242.22 476.812 1230.28 489.739C1228.5 491.656 1228.98 495.403 1231.88 496C1248.97 499.532 1268.05 503.352 1285.51 501.429C1287.91 501.163 1289.13 497.301 1286.21 496.758C1273.83 494.445 1261.34 493.385 1248.91 491.54C1250.85 491.28 1252.77 490.974 1254.71 490.597C1261.91 489.175 1269.01 487.275 1275.96 484.912C1290.09 480.097 1303.66 473.775 1316.43 466.054C1341.15 451.1 1362.97 431.819 1380.86 409.132C1397.95 387.656 1411.4 363.517 1420.66 337.68C1430.35 310.598 1434.76 281.911 1433.65 253.17C1433.03 237.922 1430.85 222.778 1427.14 207.976C1423.48 193.471 1418.5 178.855 1411.27 165.719C1409.46 162.431 1407.42 159.271 1405.18 156.261C1404.74 155.573 1404.06 155.08 1403.28 154.882C1402.49 154.685 1401.66 154.799 1400.95 155.201C1400.25 155.604 1399.73 156.263 1399.5 157.041C1399.27 157.819 1399.35 158.655 1399.72 159.376Z",
    fill: "#F5F8FF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_53645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1425,
    height: 905.33,
    fill: "white",
    transform: "translate(-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26_53645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1547,
    height: 845,
    fill: "white",
    transform: "translate(-66 30.1562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg0);
export default __webpack_public_path__ + "static/media/bg0.c07976748da3fed2baeedf99ae9facf5.svg";
export { ForwardRef as ReactComponent };